// BubbleChat.js - Updated with ElevenLabs TTS

import React, { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import { generateBubbleChat } from "../apis";
import "../style.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import LMSStyle from "./LMSStyle";
import HeygenStyle from "./HeygenStyle";
import DefaultStyle from "./DefaultStyle";
import LMSQuizStyle from "./LMSQuizStyle";
import LMSActivityStyle from "./LMSActivityStyle";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";

  // ElevenLabs API Configuration
const ELEVENLABS_API_KEY = 'sk_41c4c2aed46d1f7b9a2cd1f4a1f1dc5cb666e91cc46102a0'; // Replace with your actual API key
const ELEVENLABS_API_URL = 'https://api.elevenlabs.io/v1';

// Voice IDs for different characters - replace with your actual voice IDs from ElevenLabs
const ELEVENLABS_VOICE_MAP = {
  default: 'j1R16HPdHkTljfMFjWBs', // Example voice ID - replace with your preferred default voice
  ren: 'wJH1bZmBUIfpUYrl489F',     // Example voice ID - replace for character "ren"
  ivy: 'DyRgVG0XuMGmW5oj528s',     // Example voice ID - replace for character "ivy" 
  felix: '8G5G4m0tC2GVqquHV88a',    // Example voice ID - replace for character "felix"
  //felix: 'x9qnEOK2bn2vJQDYxfFe',    // Example voice ID - replace for character "felix"
  gold: 'j1R16HPdHkTljfMFjWBs',      // Example voice ID - replace for character "gold"
  alex:    'O0P5ADT4XwluX8kXUii0'
};

// ElevenLabs model selection - use the faster model
const ELEVENLABS_MODEL = 'eleven_flash_v2_5'; // Use turbo model for faster generation

// HeyGen TTS and avatar streaming constants (keeping these for HeyGen functionality)
const HEYGEN_API_KEY = 'OTQ2MzIzMmNkM2U1NDAzODk2OGRhNTU3MWY1NDAzYTMtMTczNDExMDc3OQ==';
const HEYGEN_SERVER_URL = 'https://api.heygen.com';
const HEYGEN_AVATAR_ID = 'ef08039a41354ed5a20565db899373f3';
const HEYGEN_VOICE_ID = '1bd001e7e50f421d891986aad5158bc8';

// Speech SDK still needed for speech recognition/voice input
const SPEECH_KEY = '4qJDg7p3eSOWexOkXWFz8b1Zh2uSTmlN8X3iZu9ZH6YTiubpaBmTJQQJ99BCACYeBjFXJ3w3AAAYACOGfDLx';
const SPEECH_REGION = 'eastus';

function BubbleChat({
  activeChat,
  setActiveChat,
  setQueries,
  questionList,
  setQuestionList,
  avatar,
  session_id,
  class_id,
}) {
  const serverAddress = process.env.REACT_APP_URL;
  const activeModel = useSelector((store) => store.auth.activeModel);
  const [question, setQuestion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const messagesContainerRef = useRef(null);
  const timestampedQuestions = useRef([]);
  const location = useLocation();
  const [initialMessage, setInitialMessage] = useState("System Message: Please continue the user where they have left off or introduce them into the lesson as if they haven't sent any messages prior to this.");
  const [isLMSStyle, setIsLMSStyle] = useState(false);
  const [isHeygenStyle, setIsHeygenStyle] = useState(false);
  const [isLMSQuizStyle, setIsLMSQuizStyle] = useState(false);
  const [isLMSActivityStyle, setIsLMSActivityStyle] = useState(false);
  const [isLMSQuizStyle2, setIsLMSQuizStyle2] = useState(false);
  const [isLMSQuizStyle3, setIsLMSQuizStyle3] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  // Typewriter effect states
  const [displayedText, setDisplayedText] = useState("");
  const [typingIndex, setTypingIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(false);
  const [skipTyping, setSkipTyping] = useState(false);

  // TTS enabled or not
  const [isTTSEnabled, setIsTTSEnabled] = useState(true);

  // Delay (ms) between typed characters (or words) – adjusted after TTS
  const [typingDelay, setTypingDelay] = useState(null);

  // Char param from URL
  const [charParam, setCharParam] = useState("");

  // Speech references for voice recognition - still using Azure for this part
  const speechConfig = useRef(null);
  const audioConfig = useRef(null);
  const recognizer = useRef(null);
  const speechSynthesizer = useRef(null); // Changed name to avoid confusion
  
  // For voice-to-text (speech recognition)
  const [isListening, setIsListening] = useState(false);

  // **NEW** peer connection for HeyGen
  const peerConnection = useRef(null);
  const sessionInfo = useRef(null); // Holds the session info for streaming

  // **NEW** reference to pause repeated TTS calls on hover
  const ttsHoverPauseRef = useRef(false);

  // **NEW** store which texts have already been spoken
  const spokenHoverTextsRef = useRef(new Set());

  // Audio elements and controls for ElevenLabs
  const audioRef = useRef(new Audio());
  const isAudioPlayingRef = useRef(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const audioQueue = useRef([]);
  const isProcessingAudio = useRef(false);

  // ADD THIS NEW REF AFTER YOUR EXISTING REFS:
  const currentMessageRef = useRef("");

  // ----------  PRONUNCIATION  DICTIONARY  ---------- //
const IYKYK_XML_DICTIONARY = `<?xml version="1.0" encoding="utf-8"?>
<lexicon version="1.0"
         xmlns="http://www.w3.org/2005/01/pronunciation-lexicon"
         xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
         xsi:schemaLocation="http://www.w3.org/2005/01/pronunciation-lexicon
           http://www.w3.org/TR/2007/CR-pronunciation-lexicon-20071212/pls.xsd"
         alphabet="ipa" xml:lang="en-US">
  <lexeme>
    <grapheme>IYKYK</grapheme>
    <alias>eye why kay why kay</alias>
  </lexeme>
  <lexeme>
    <grapheme>iykyk</grapheme>
    <alias>eye why kay why kay</alias>
  </lexeme>
</lexicon>`;

// in-memory cache so we only upload / fetch once
const iykykDictRef = { id: null, version_id: null };

  useEffect(() => {
  const params = new URLSearchParams(location.search);
  const startingMessage = params.get("starting_message");
  const styleParam = params.get("style");
  const charFromUrl = params.get("char") || "";

  setCharParam(charFromUrl);

  if (startingMessage) {
    setInitialMessage(startingMessage);
    // Clear it immediately after being set
    setTimeout(() => {
      setInitialMessage("");
    }, 0);
  }

  // Style checks
  if (styleParam === "lms") {
    setIsLMSStyle(true);
    setIsOpen(true);
  }
  if (styleParam === "heygen") {
    setIsHeygenStyle(true);
    setIsOpen(true);
    initializeSession(); // Start HeyGen avatar session
  }
  if (styleParam === "lmsquiz") {
    setIsLMSQuizStyle(true);
    setIsOpen(true);
  }
  if (styleParam === "lmsquiz2") {
    setIsLMSQuizStyle2(true);
    setIsOpen(true);
  }
  if (styleParam === "lmsquiz3") {
    setIsLMSQuizStyle3(true);
    setIsOpen(true);
  }
  if (styleParam === "lmsactivity") {
    setIsLMSActivityStyle(true);
    setIsOpen(true);
  }

  // Initialize speech config for voice input recognition only
  speechConfig.current = sdk.SpeechConfig.fromSubscription(SPEECH_KEY, SPEECH_REGION);
  speechConfig.current.speechRecognitionLanguage = "en-US";

  // Initialize audio config, recognizer for voice input
  audioConfig.current = sdk.AudioConfig.fromDefaultMicrophoneInput();
  recognizer.current = new sdk.SpeechRecognizer(speechConfig.current, audioConfig.current);

  // Recognizer events
  recognizer.current.recognized = (s, e) => processRecognizedTranscript(e);
  recognizer.current.recognizing = (s, e) => processRecognizingTranscript(e);

  // ensure the IYKYK dictionary has been uploaded
  (async function initIykykDict() {
    if (iykykDictRef.id) return;               // already cached

    // STEP ➊ – create a pronunciation dictionary shell
    const createRes = await fetch(
      `${ELEVENLABS_API_URL}/pronunciation-dictionaries/add-from-file`,
      {
        method: 'POST',
        headers: {
          'xi-api-key': ELEVENLABS_API_KEY
        },
        body: (() => {
          const fd = new FormData();
          fd.append('name', 'iykyk-inline');
          fd.append('file', new Blob([IYKYK_XML_DICTIONARY], { type: 'text/xml' }),
                    'iykyk.pls');
          return fd;
        })()
      }
    );

    if (!createRes.ok) {
      console.error('Could not create IYKYK dict', await createRes.text());
      return;
    }

    const { id: dictId, version_id } = await createRes.json();
    iykykDictRef.id = dictId;
    iykykDictRef.version_id = version_id;
    console.log('IYKYK dict ready →', iykykDictRef);
  })();

  return () => {
    // Cleanup: stop any speech recognition
    if (recognizer.current) {
      recognizer.current.stopContinuousRecognitionAsync(() => {
        setIsListening(false);
      });
    }
    
    // Clean up audio handlers
    cleanupAudioHandlers();
    
    // Stop any playing audio
    if (audioRef.current) {
      audioRef.current.pause();
      if (audioRef.current.src && audioRef.current.src.startsWith('blob:')) {
        URL.revokeObjectURL(audioRef.current.src);
      }
      audioRef.current.src = '';
    }
    
    // Clear audio queue
    audioQueue.current = [];
    isProcessingAudio.current = false;
  };
}, [location]);

// ADD THIS NEW FUNCTION BEFORE YOUR EXISTING FUNCTIONS:
const cleanupAudioHandlers = () => {
  if (audioRef.current) {
    audioRef.current.onloadedmetadata = null;
    audioRef.current.onplay = null;
    audioRef.current.onended = null;
    audioRef.current.onerror = null;
    audioRef.current.oncanplay = null;
  }
};
  const processRecognizedTranscript = (event) => {
    const result = event.result;
    if (result.reason === sdk.ResultReason.RecognizedSpeech) {
      const transcript = result.text.trim();
      setQuestion((prevQuestion) =>
        prevQuestion ? `${prevQuestion} ${transcript}` : transcript
      );
    }
  };

  const processRecognizingTranscript = (event) => {
    const result = event.result;
    if (result.reason === sdk.ResultReason.RecognizingSpeech) {
      const transcript = result.text.trim();
      // If partial accumulation is wanted, uncomment:
      // setQuestion((prevQuestion) =>
      //   prevQuestion ? `${prevQuestion} ${transcript}` : transcript
      // );
    }
  };

  const handleVoiceInput = () => {
    if (isListening) {
      recognizer.current.stopContinuousRecognitionAsync(() => {
        console.log("Speech recognition stopped.");
        setIsListening(false);
      });
    } else {
      recognizer.current.startContinuousRecognitionAsync(() => {
        console.log("Speech recognition started.");
        setIsListening(true);
      });
    }
  };

  const stopSpeechRecognition = (reason) => {
    if (isListening) {
      recognizer.current.stopContinuousRecognitionAsync(() => {
        console.log(`Speech recognition stopped due to ${reason}.`);
        setIsListening(false);
      });
    }
  };

  // ---------------------
  // HeyGen session - kept the same
  // ---------------------
  const initializeSession = async () => {
    try {
      console.log("Initializing session...");
      sessionInfo.current = await createNewSession();
      await startAndDisplaySession();
    } catch (error) {
      console.error("Error initializing HeyGen session:", error);
    }
  };

  const createNewSession = async () => {
    const response = await fetch(`${HEYGEN_SERVER_URL}/v1/streaming.new`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': HEYGEN_API_KEY,
      },
      body: JSON.stringify({
        quality: 'low',
        avatar_name: HEYGEN_AVATAR_ID,
        voice: { voice_id: HEYGEN_VOICE_ID },
      }),
    });

    if (response.status !== 200) {
      throw new Error('Failed to create session');
    }
    const data = await response.json();
    return data.data;
  };

  const startAndDisplaySession = async () => {
    if (!sessionInfo.current) {
      return;
    }

    const { sdp: serverSdp, ice_servers2: iceServers } = sessionInfo.current;
    peerConnection.current = new RTCPeerConnection({ iceServers });

    peerConnection.current.ontrack = (event) => {
      if (event.track.kind === 'audio' || event.track.kind === 'video') {
        const mediaElement = document.querySelector('#mediaElement');
        if (mediaElement) {
          mediaElement.srcObject = event.streams[0];
        }
      }
    };

    peerConnection.current.onicecandidate = ({ candidate }) => {
      if (candidate) {
        handleICE(sessionInfo.current.session_id, candidate.toJSON());
      }
    };

    const remoteDescription = new RTCSessionDescription(serverSdp);
    await peerConnection.current.setRemoteDescription(remoteDescription);

    const localDescription = await peerConnection.current.createAnswer();
    await peerConnection.current.setLocalDescription(localDescription);

    await startSession(sessionInfo.current.session_id, localDescription);
  };

  const handleICE = async (session_id, candidate) => {
    const response = await fetch(`${HEYGEN_SERVER_URL}/v1/streaming.ice`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': HEYGEN_API_KEY,
      },
      body: JSON.stringify({ session_id, candidate }),
    });

    if (response.status !== 200) {
      throw new Error('Failed to handle ICE');
    }
  };

  const startSession = async (session_id, sdp) => {
    const response = await fetch(`${HEYGEN_SERVER_URL}/v1/streaming.start`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': HEYGEN_API_KEY,
      },
      body: JSON.stringify({ session_id, sdp }),
    });

    if (response.status !== 200) {
      throw new Error('Failed to start session');
    }
  };

  // HeyGen TTS - kept the same
  const heyGenTTS = async (text) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${HEYGEN_SERVER_URL}/v1/streaming.task`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Api-Key': HEYGEN_API_KEY,
          },
          body: JSON.stringify({
            session_id: sessionInfo.current.session_id,
            text: text,
          }),
        });

        if (response.status !== 200) {
          reject(new Error('Failed to process TTS'));
          return;
        }
        // No direct "done" callback from HeyGen, but we assume success quickly
        setTimeout(() => {
          resolve();
        }, 1000); // small delay
      } catch (error) {
        console.error('Error in HeyGen TTS:', error);
        reject(error);
      }
    });
  };

// Updated helper function that works with the existing extractOptions logic
const buildTTSTextWithPauses = (originalText, char, isLMSActivityStyle) => {
  if (!originalText || typeof originalText !== 'string') {
    return originalText;
  }

  // Skip option extraction for gold character (same logic as extractOptions)
  if (char === "gold") {
    return originalText;
  }

  // Use the same extraction logic as extractOptions to split question from answers
  const options = {};
  const questionOnlyText = originalText.replace(
    /([1-9])\)\s*(.*?)(?=(?:[1-9]\)|$))/g,
    (match, option, answer) => {
      const sanitizedAnswer = String(answer).replace(/[?,]/g, "").trim();
      options[option] = sanitizedAnswer;
      return ""; // Remove from main text
    }
  );

  // If no options were found, return original text (no numbered answers)
  if (Object.keys(options).length === 0) {
    return originalText;
  }

  // Build TTS text: Question + pause + each answer with pauses between
  let ttsText = questionOnlyText.trim();
  
  // Add pause between question and first answer
  ttsText += '<break time="1.5s"/>';
  
  // Add each option with pauses between them
  const optionEntries = Object.entries(options);
  optionEntries.forEach(([key, value], index) => {
    // For LMSActivityStyle (and not gold), don't include the numbers - just read the answers
    if (isLMSActivityStyle && char !== "gold") {
      ttsText += value; // Just the answer text, no "1)" "2)" etc.
    } else {
      ttsText += `${key}) ${value}`; // Include numbers for other styles
    }
    
    // Add pause between options (but not after the last one)
    if (index < optionEntries.length - 1) {
      ttsText += '<break time="1.5s"/>';
    }
  });

  return ttsText;
};

// Enhanced ElevenLabs TTS Function using existing button splitting logic
const elevenLabsTTS = async (text) => {
  return new Promise(async (resolve, reject) => {
    try {
      // Input validation
      if (!text || typeof text !== 'string' || text.trim() === '') {
        console.warn('Invalid text provided to TTS');
        resolve();
        return;
      }

      // Filter out disallowed characters (but keep numbered options for now)
      let filtered_text;
      if (isLMSActivityStyle && charParam !== "gold") {
        // Don't remove numbered options here - we'll handle them specially
        filtered_text = text.replace(/#/g, "");
      } else {
        filtered_text = text.replace(/#/g, "");
      }

      // Use the smart pause logic that leverages existing button splitting
      const textWithPauses = buildTTSTextWithPauses(filtered_text, charParam, isLMSActivityStyle);

      // Get voice ID based on character parameter
      let voiceId = ELEVENLABS_VOICE_MAP.default;
      if (charParam && ELEVENLABS_VOICE_MAP[charParam]) {
        voiceId = ELEVENLABS_VOICE_MAP[charParam];
      }

      // Voice settings - consistent across all characters
      let voiceSettings = {
        stability: 0.3,
        similarity_boost: 0.5,
        style: 1.0,
        use_speaker_boost: true
      };

      // Set streaming parameters for speed optimization
      const streamParams = {
        output_format: "mp3_44100_128",
        optimize_streaming_latency: 4,
        model: ELEVENLABS_MODEL
      };

      // Prepare request body
      const requestBody = {
        text: textWithPauses, // Use intelligently built text with pauses
        model_id: ELEVENLABS_MODEL,
        voice_settings: voiceSettings,
        ...streamParams
      };

      // Add pronunciation dictionary if available
      if (iykykDictRef.id) {
        requestBody.pronunciation_dictionary_locators = [
          { id: iykykDictRef.id, version_id: iykykDictRef.version_id }
        ];
      }

      // Make API call to ElevenLabs
      const response = await fetch(`${ELEVENLABS_API_URL}/text-to-speech/${voiceId}/stream`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'xi-api-key': ELEVENLABS_API_KEY,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('ElevenLabs API error:', errorData);
        reject(new Error(`Failed to process TTS: ${response.status} - ${errorData.detail || 'Unknown error'}`));
        return;
      }

      // Get the audio blob
      const audioBlob = await response.blob();
      
      // Validate audio blob
      if (!audioBlob || audioBlob.size === 0) {
        console.error('Received empty audio blob from ElevenLabs');
        reject(new Error('Received empty audio response'));
        return;
      }

      const audioUrl = URL.createObjectURL(audioBlob);
      
      // Set up the audio element with proper event handlers
      const audioElement = audioRef.current;
      
      // ALWAYS cleanup first using the cleanup function
      cleanupAudioHandlers();
      
      // Track if promise has been resolved to prevent double resolution
      let hasResolved = false;
      const resolveOnce = () => {
        if (!hasResolved) {
          hasResolved = true;
          resolve();
        }
      };

      // Set up new event handlers
      audioElement.onloadedmetadata = () => {
        try {
          // Now we have the actual audio duration
          const audioDurationMs = audioElement.duration * 1000;
          
          // Validate audio duration
          if (!audioDurationMs || audioDurationMs <= 0) {
            console.warn('Invalid audio duration detected');
            setTypingDelay(50); // Fallback typing delay
            return;
          }
          
          // IMPORTANT: Calculate typing delay based on ORIGINAL text length 
          // (what's displayed) but using the audio duration of enhanced text (what's spoken)
          const originalTextLength = text.length; // Use original text for typing calculation
          
          // Calculate typing delay to match audio duration
          // Add small buffer (0.95) so typing finishes slightly before audio
          const calculatedDelay = (audioDurationMs * 0.95) / originalTextLength;
          
          // Set reasonable bounds (minimum 25ms, maximum 150ms per character)
          const boundedDelay = Math.min(Math.max(calculatedDelay, 25), 150);
          
          console.log(`Smart TTS (1.5s pauses) - Audio duration: ${audioDurationMs}ms, Original text length: ${originalTextLength}, Enhanced text: "${textWithPauses.substring(0, 100)}...", Calculated delay: ${calculatedDelay}ms, Bounded delay: ${boundedDelay}ms`);
          
          setTypingDelay(boundedDelay);
        } catch (error) {
          console.error('Error in onloadedmetadata:', error);
          setTypingDelay(50); // Fallback delay
        }
      };

      audioElement.oncanplay = () => {
        console.log("Smart TTS audio ready to play");
      };

      audioElement.onplay = () => {
        isAudioPlayingRef.current = true;
        setIsAudioPlaying(true);
        
        // Always start typing with fallback delay if metadata hasn't loaded yet
        setTypingDelay(prev => prev || 50);
        setIsTyping(true);
        
        console.log("Smart TTS started playing, typing started");
      };

      audioElement.onended = () => {
        // Audio finished playing, complete typing immediately
        isAudioPlayingRef.current = false;
        setIsAudioPlaying(false);
        setIsTyping(false);
        
        // Complete typing immediately using currentMessageRef
        const currentMessage = currentMessageRef.current;
        if (currentMessage) {
          setDisplayedText(currentMessage);
          setTypingIndex(currentMessage.length);
        }
        
        console.log("Smart TTS ended, typing completed");
        
        // Clean up the blob URL
        try {
          URL.revokeObjectURL(audioUrl);
        } catch (error) {
          console.warn('Error revoking blob URL:', error);
        }
        
        // Process next item in queue if any
        if (audioQueue.current.length > 0) {
          processAudioQueue();
        }
        
        resolveOnce();
      };

      audioElement.onerror = (error) => {
        console.error("Audio playback failed:", error);
        cleanupAudioHandlers();
        isAudioPlayingRef.current = false;
        setIsAudioPlaying(false);
        setIsTyping(false);
        
        try {
          URL.revokeObjectURL(audioUrl);
        } catch (e) {
          console.warn('Error revoking blob URL on error:', e);
        }
        
        reject(new Error(`Audio playback failed: ${error.message || 'Unknown audio error'}`));
      };

      audioElement.onabort = () => {
        console.warn("Audio loading was aborted");
        cleanupAudioHandlers();
        try {
          URL.revokeObjectURL(audioUrl);
        } catch (e) {
          console.warn('Error revoking blob URL on abort:', e);
        }
        reject(new Error('Audio loading was aborted'));
      };

      audioElement.onstalled = () => {
        console.warn("Audio loading stalled");
      };

      // Set the audio source and load it
      audioElement.src = audioUrl;
      audioElement.playbackRate = 1.0;
      
      // Load the audio to trigger metadata loading
      try {
        audioElement.load();
      } catch (error) {
        console.error('Error loading audio:', error);
        reject(error);
        return;
      }
      
      // Attempt to play with proper error handling
      const playPromise = audioElement.play();
      if (playPromise !== undefined) {
        playPromise.catch(err => {
          console.error("Audio playback failed:", err);
          cleanupAudioHandlers();
          isAudioPlayingRef.current = false;
          setIsAudioPlaying(false);
          setIsTyping(false);
          
          try {
            URL.revokeObjectURL(audioUrl);
          } catch (e) {
            console.warn('Error revoking blob URL on play failure:', e);
          }
          
          reject(new Error(`Audio play failed: ${err.message || 'Unknown play error'}`));
        });
      }
      
    } catch (error) {
      console.error('Error in Smart TTS:', error);
      
      // Ensure audio state is cleaned up on any error
      isAudioPlayingRef.current = false;
      setIsAudioPlaying(false);
      setIsTyping(false);
      
      reject(error);
    }
  });
};

  // Updated textToSpeech function with better error handling and coordination
const textToSpeech = async (text) => {
  // Always stop any existing TTS first
  handleStopTTS();
  
  return new Promise((resolve, reject) => {
    if (!isTTSEnabled || !text || text.trim() === "") {
      // If TTS is disabled, still provide a simple typing effect
      setTypingDelay(30);
      setIsTyping(true);
      resolve();
      return;
    }

    // If using HeyGen style, use HeyGen TTS
    if (isHeygenStyle) {
      heyGenTTS(text)
        .then(() => {
          // For HeyGen, provide a simple typing effect since we can't sync with their audio
          setTypingDelay(30);
          setIsTyping(true);
          resolve();
        })
        .catch(reject);
      return;
    }

    // Otherwise use ElevenLabs TTS
    elevenLabsTTS(text)
      .then(resolve)
      .catch((err) => {
        console.error("ElevenLabs TTS failed:", err);
        // If ElevenLabs fails, provide fallback typing effect
        setTypingDelay(30);
        setIsTyping(true);
        resolve();
      });
  });
};

  // ---------------------
  // Typewriter effect - kept mostly the same
  // ---------------------
  // Updated typewriter effect - simplified and consistent
useEffect(() => {
  const currentMessage = currentMessageRef.current;

  // If no message or user has skipped
  if (!currentMessage || skipTyping) {
    setIsTyping(false);
    return;
  }

  // If typing has finished
  if (typingIndex >= currentMessage.length) {
    setIsTyping(false);
    return;
  }

  // If typing is not enabled or typingDelay is not set
  if (!isTyping || typingDelay === null) {
    return;
  }

  // Character-by-character typing for all styles (simplified)
  const timer = setTimeout(() => {
    setDisplayedText(currentMessage.slice(0, typingIndex + 1));
    setTypingIndex(typingIndex + 1);
  }, typingDelay);

  return () => clearTimeout(timer);
}, [
  // REMOVED activeChat.queries - this was causing the flicker!
  typingIndex,
  skipTyping,
  typingDelay,
  isTyping,
]);

  // Updated handleStopTTS to properly clean up all states
const handleStopTTS = () => {
  // Stop the audio
  if (audioRef.current) {
    try {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      
      // Use the cleanup function
      cleanupAudioHandlers();
      
      // If there's a blob URL, revoke it
      if (audioRef.current.src && audioRef.current.src.startsWith('blob:')) {
        URL.revokeObjectURL(audioRef.current.src);
      }
      
      audioRef.current.src = '';
    } catch (e) {
      console.error("Error stopping audio:", e);
    }
  }
  
  // Update audio state
  isAudioPlayingRef.current = false;
  setIsAudioPlaying(false);
  
  // Stop typing effect
  setIsTyping(false);
  
  // Clear audio queue
  audioQueue.current = [];
  isProcessingAudio.current = false;
};

  const handleSkipTyping = () => {
  // Stop TTS and audio
  handleStopTTS();
  
  // Get the current message from ref instead of reactive state
  const currentMessage = currentMessageRef.current;

  if (currentMessage) {
    setDisplayedText(currentMessage);
    setTypingIndex(currentMessage.length);
  }
  
  // Stop typing effect
  setIsTyping(false);
  setSkipTyping(true);
  
  // Reset typing delay
  setTypingDelay(null);
};


  // Audio queue processing function
  const processAudioQueue = async () => {
    if (isProcessingAudio.current || audioQueue.current.length === 0) {
      return;
    }
    
    isProcessingAudio.current = true;
    setIsAudioPlaying(true);
    
    const nextAudio = audioQueue.current.shift();
    try {
      // Stop any existing audio first
      handleStopTTS();
      
      // Play the next audio
      await textToSpeech(nextAudio.text);
    } catch (error) {
      console.error("Error processing audio in queue:", error);
    } finally {
      isProcessingAudio.current = false;
      setIsAudioPlaying(false);
      
      // Process the next item in queue if any
      if (audioQueue.current.length > 0) {
        processAudioQueue();
      }
    }
  };

  // Function to add audio to the queue
  const queueAudio = (text, priority = false) => {
    if (!isTTSEnabled || !text || text.trim() === "") {
      return;
    }
    
    // If priority, clear the queue and stop current audio
    if (priority) {
      audioQueue.current = [];
      handleStopTTS();
    }
    
    // Add to queue
    audioQueue.current.push({ text });
    
    // Start processing if not already
    if (!isProcessingAudio.current) {
      processAudioQueue();
    }
  };

  // Updated speakHoverText to work with ElevenLabs
  const speakHoverText = (hoverText) => {
    // Skip if: gold style, TTS not enabled, or no text
    if (charParam === "gold" || !isTTSEnabled || isTTSEnabled) return;
    if (!hoverText || hoverText.trim() === "") return;

    handleStopTTS();
  
    // If currently typing out a main message, don't interrupt with hover text
    if (isTyping) return;
  
    // If not in pause period (to prevent rapid-fire TTS)
    if (!ttsHoverPauseRef.current) {
      // Always stop any current TTS before starting a new one
      handleStopTTS();
      
      // Start the new TTS
      textToSpeech(hoverText);
      
      // Add to spoken texts set (for logging purposes if needed)
      spokenHoverTextsRef.current.add(hoverText);
      
      // Set pause period (to prevent TTS spam)
      ttsHoverPauseRef.current = true;
      setTimeout(() => {
        ttsHoverPauseRef.current = false;
      }, 800); // Reduced to 800ms to make it more responsive but still prevent spam
    }
  };

  // The rest of your code remains the same
  const handleInputChange = (input) => {
    const newValue = typeof input === "string" ? input : input?.target?.value || "";
    setQuestion(newValue);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleSendMessage = async (msg = question) => {
  const messageToSend = typeof msg === "string" ? msg : String(msg);
  if (!messageToSend || isLoading || isTyping) {
    return;
  }

  const timestamp = new Date().toLocaleString();
  const messageWithTimestamp = `${messageToSend} (Sent at: ${timestamp})`;

  setQuestionList([...questionList, messageToSend]);
  timestampedQuestions.current.push(messageWithTimestamp);

  let payload = {
    question: messageWithTimestamp,
    modelId: activeModel,
    session_id,
    class_id,
    isBubble: true,
  };

  if (!activeChat.id) {
    const splitQues = messageToSend.split(" ");
    payload.isNew = true;
    payload.title = splitQues[0] + " " + (splitQues[1] || "") + " " + (splitQues[2] || "");
  } else {
    payload.id = activeChat.id;
  }

  // If it's an LMS quiz style or LMS activity style
  if (isLMSQuizStyle) {
    payload.isLMSQuiz = true;
  }
  if (isLMSActivityStyle) {
    payload.isLMSActivity = true;
  }

  setIsLoading(true);
  setQuestion("");

  try {
    // Step 1: Get GPT response
    const res = await generateBubbleChat(payload);
    setQueries(res.data.chats);

    const oldActiveChat = res.data.chats.find(
      (chat) => chat.id === activeChat.id
    );
    const chat = oldActiveChat
      ? oldActiveChat
      : res.data.chats[res.data.chats.length - 1];
    setActiveChat(chat);

    setIsLoading(false);

    // Step 2: Handle the new message
    const latestMessageIndex = chat.queries.length - 1;
    if (latestMessageIndex >= 0) {
      const latestMessage = chat.queries[latestMessageIndex].solution;
      
      if (latestMessage) {
        // Store the current message in ref FIRST
        currentMessageRef.current = latestMessage;
        
        // Reset ALL typing states in proper order
        setSkipTyping(false);
        setIsTyping(false);
        setTypingIndex(0);
        setDisplayedText("");
        setTypingDelay(null);
        
        // Wait for state to settle before starting TTS
        setTimeout(async () => {
          try {
            await textToSpeech(latestMessage);
          } catch (err) {
            console.error("Error during TTS:", err);
            // If TTS fails, still show the text with a simple typing effect
            setTypingDelay(30);
            setIsTyping(true);
          }
        }, 10); // Small delay to let state updates process
      }
    }
  } catch (err) {
    toast("Something went wrong. Please check retrain model status", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setIsLoading(false);
  }
};

  const handleBubbleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleInputFocus = () => {
    stopSpeechRecognition("input focus");
  };

  // Common props for child style components
  const getCommonProps = () => ({
    displayedText,
    initialMessage,
    question,
    handleVoiceInput,
    isListening,
    inputRef: null,
    handleInputChange,
    handleKeyDown,
    handleInputFocus,
    handleSendMessage,
    isLoading,
    isTyping,
    handleSkipTyping,
    messagesContainerRef,
    setQuestion,
  });

  // Render based on style
  if (isLMSStyle) {
    return (
      <LMSStyle
        {...getCommonProps()}
        session_id={session_id}
        class_id={class_id}
        isTTSEnabled={isTTSEnabled}
        setIsTTSEnabled={setIsTTSEnabled}
        handleStopTTS={handleStopTTS}
        darkMode={darkMode}
        setDarkMode={setDarkMode}
        avatar={avatar}
        serverAddress={serverAddress}
        char={charParam}
      />
    );
  } else if (isHeygenStyle) {
    return (
      <HeygenStyle
        {...getCommonProps()}
      />
    );
  } else if (isLMSQuizStyle) {
    return (
      <LMSQuizStyle
        {...getCommonProps()}
        speakHoverText={speakHoverText}
        session_id={session_id}
        class_id={class_id}
        isTTSEnabled={isTTSEnabled}
        setIsTTSEnabled={setIsTTSEnabled}
        handleStopTTS={handleStopTTS}
        char={charParam}
        questionList={questionList}
        activeChat={activeChat}
        timestampedQuestions={timestampedQuestions}
        isLoading={isLoading}
      />
    );
  } else if (isLMSActivityStyle) {
    return (
      <LMSActivityStyle
        {...getCommonProps()}
        speakHoverText={speakHoverText}
        session_id={session_id}
        class_id={class_id}
        isTTSEnabled={isTTSEnabled}
        setIsTTSEnabled={setIsTTSEnabled}
        handleStopTTS={handleStopTTS}
        char={charParam}
        questionList={questionList}
        activeChat={activeChat}
        timestampedQuestions={timestampedQuestions}
        isLoading={isLoading}
      />
    );
  } else {
    // Default style
    return (
      <DefaultStyle
        isOpen={isOpen}
        avatar={avatar}
        serverAddress={serverAddress}
        questionList={questionList}
        activeChat={activeChat}
        timestampedQuestions={timestampedQuestions}
        isLoading={isLoading}
        question={question}
        handleInputChange={handleInputChange}
        handleKeyDown={handleKeyDown}
        handleSendMessage={handleSendMessage}
        handleBubbleClick={handleBubbleClick}
        messagesContainerRef={messagesContainerRef}
      />
    );
  }
}

export default BubbleChat;